import type { AxiosInstance, AxiosResponse } from "axios";
import type { RequestArgs } from "./base";
import type { Configuration } from "./configuration";

/**
 *
 * @export
 */
export const createRequestFunction = function (
  axiosArgs: RequestArgs,
  globalAxios: AxiosInstance,
  configuration: Configuration,
) {
  return <T = unknown, R = AxiosResponse<T>>(
    axios: AxiosInstance = globalAxios,
  ) => {
    const axiosRequestArgs = {
      ...axiosArgs.options,
      url: configuration?.basePath + axiosArgs.url,
    };
    return axios.request<T, R>(axiosRequestArgs);
  };
};
